import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface ProjectDetails {
  _id: string;
  name: string;
  ghg_project_summary: string;
  method_id: string | string[];
  status: string;
  organization: string;
  [key: string]: any;
}

export interface ProjectDetailsResponse {
  data: ProjectDetails[];
}

export interface DocumentIds {
  docids: (string | number)[];
}

export interface YieldDetails {
  yield_id?: string | any[];
  period: string;
  co2_estimated?: number;
  co2_realized?: number;
  pre_credits?: number | null;
  credits?: number;
  storage_duration?: number;
  [key: string]: any;
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryProjectDetailsApi = createApi({
  reducerPath: "registryprojectdetails",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["RegistryProjectDetails"],
  endpoints: (build) => ({
    getRegistryProjectDetails: build.query<ProjectDetailsResponse, string>({
      query: (id) => `rs/registry/project/${id}`,
      providesTags: ["RegistryProjectDetails"],
    }),
    getRegistryProjectDocumentIds: build.query<DocumentIds, string>({
      query: (id) => `rs/registry/document/${id}`,
      providesTags: ["RegistryProjectDetails"],
    }),
    getRegistryProjectYieldDetails: build.query<YieldDetails[], string>({
      query: (id) => `rs/registry/yield/${id}`,
      providesTags: ["RegistryProjectDetails"],
    }),
  }),
});

export const {
  useGetRegistryProjectDetailsQuery,
  useGetRegistryProjectDocumentIdsQuery,
  useGetRegistryProjectYieldDetailsQuery,
} = registryProjectDetailsApi;
